import { keyValue, keyValueObject, keyValuePair } from './types'

// Add proper interfaces for URL objects
interface URLTypeWithIsPrivate {
  cdn_url: string
  isPrivate: boolean
  id?: string
}

interface URLTypeWithIsPrivateFile {
  cdn_url: string
  is_private_file: boolean
  id?: string
}

export enum FormElementNames {
  element = 'element',
  element_type = 'element_type',
  element_mod_type = 'element_mod_type',
  element_mod_details = 'element_mod_details',
  element_mod = 'element_mod',
  element_type_display_order = 'element_type_display_order',
  element_orientation = 'element_orientation',
  orientation = 'orientation',
  element_material = 'element_material',
  element_material_conf = 'element_material_conf',
  element_construction = 'element_construction',
  element_construction_abr = 'element_construction_abr',
  element_display_1 = 'element_display_1',
  element_display_2 = 'element_display_2',
  product_installation_type = 'product_installation_type',
  installation_type = 'installation_type',
  product_installations = 'product_installations',
  product_instruction_list = 'product_instruction_list',
  product_type = 'product_type',
  product_manufacturer = 'product_manufacturer',
  product_brand = 'product_brand',
  product_category = 'product_category',
  category_display_order = 'category_display_order',
  product_sub_category = 'product_sub_category',
  sub_category_display_order = 'sub_category_display_order',
  sub_category_description = 'sub_category_description',
  product_notes = 'product_notes',
  base_diameter_unit = 'base_diameter_unit',
  inside_diameter_unit = 'inside_diameter_unit',
  inside_diameter = 'inside_diameter',
  inserted_on = 'inserted_on',
  updated_on = 'updated_on',
  modified_on = 'modified_on',
  thickness = 'thickness',
  thickness_unit = 'thickness_unit',
  dim_1_unit = 'dim_1_unit',
  dim_2_unit = 'dim_2_unit',
  dim_3_unit = 'dim_3_unit',
  dim_4_unit = 'dim_4_unit',
  dim_1 = 'dim_1',
  dim_2 = 'dim_2',
  dim_3 = 'dim_3',
  dim_4 = 'dim_4',
  dim_1_name = 'dim_1_name',
  dim_2_name = 'dim_2_name',
  dim_3_name = 'dim_3_name',
  dim_4_name = 'dim_4_name',
  dim_1_type = 'dim_1_type',
  dim_2_type = 'dim_2_type',
  dim_3_type = 'dim_3_type',
  dim_4_type = 'dim_4_type',
  frl = 'frl',
  frl_st = 'frl_st',
  frl_type = 'frl_type',
  is_active = 'is_active',
  is_private_file = 'is_private_file',
  is_email_verified = 'is_email_verified',
  display_order = 'display_order',
  frl_structure = 'frl_structure',
  frl_passive = 'frl_passive',
  frl_integ = 'frl_integ',
  frl_ins = 'frl_ins',
  faq_q = 'faq_q',
  faq_a = 'faq_a',
  faq_image = 'faq_image',
  faq_information_reference = 'faq_information_reference',
  base_thickness = 'base_thickness',
  added_thickness = 'added_thickness',
  element_notes = 'element_notes',
  id = 'id',
  element_name = 'element_name',
  element_abr = 'element_abr',
  selling_price = 'selling_price',
  nominal_size_unit = 'nominal_size_unit',
  nominal_size = 'nominal_size',
  display_size = 'display_size',
  height_unit = 'height_unit',
  width_unit = 'width_unit',
  height = 'height',
  width = 'width',
  base_diameter = 'base_diameter',
  report_standard_list = 'report_standard_list',
  report_type = 'report_type',
  doc_version_desc = 'doc_version_desc',
  facility = 'facility',
  report_facility = 'report_facility',
  report_publishing = 'report_publishing',
  report_status = 'report_status',
  dbase_type = 'dbase_type_id',
  report_standards = 'report_standards',
  display_status = 'display_status',
  report_notes = 'report_notes',
  product_qr_url = 'product_qr_url',
  product_url = 'product_url',
  doc_uploaded_date = 'doc_uploaded_date',
  product_docs = 'product_docs',
  system_docs = 'system_docs',
  sub_category_docs = 'sub_category_docs',
  test_date = 'test_date',
  issue_date = 'issue_date',
  expiry_date = 'expiry_date',
  publishing_notes = 'publishing_notes',
  superseded_date = 'superseded_date',
  service_material = 'service_material',
  internal_note = 'internal_note',
  service_category = 'service_category',
  service_sub_category = 'service_sub_category',
  service_sub_cat_name = 'service_sub_cat_name',
  service_manufacturer = 'service_manufacturer',
  service_brand = 'service_brand',
  service_configuration = 'service_configuration',
  service_standard = 'service_standard',
  service_std_name = 'service_std_name',
  service_std_group = 'service_std_group',
  service_std_no = 'service_std_no',
  service_std_part = 'service_std_part',
  service_std_year = 'service_std_year',
  service_std_section = 'service_std_section',
  service_std_fullname = 'service_std_fullname',
  service_std_country = 'service_std_country',
  service_std_published_date = 'service_std_published_date',
  service_type = 'service_type',
  service_add = 'service_add',
  service_add_dim = 'service_add_dim',
  service_add_unit = 'service_add_unit',
  service_add_desc = 'service_add_desc',
  service_add_material = 'service_add_material',
  service_add_notes = 'service_add_notes',
  service_add_datasheet_url = 'service_add_datasheet_url',
  service_add_type = 'service_add_type',
  service_add_manufacturer = 'service_add_manufacturer',
  service_add_brand = 'service_add_brand',
  service_add_group = 'service_add_group',
  service_add_group_desc = 'service_add_group_desc',
  service_add_group_notes = 'service_add_group_notes',
  description = 'description',
  size_unit = 'size_unit',
  service_size = 'service_size',
  actual_size = 'actual_size',
  actual_outer_dia = 'actual_outer_dia',
  actual_inner_dia = 'actual_inner_dia',
  actual_size_tol = 'actual_size_tol',
  thickness_tol = 'thickness_tol',
  material_name = 'material_name',
  material_order = 'material_order',
  service_notes = 'service_notes',
  product_instructions = 'product_instructions',
  service_standards = 'service_standards',
  display_record = 'display_record',
  priority_order = 'priority_order',
  fitting = 'fitting',
  standard_part = 'standard_part',
  standard_year = 'standard_year',
  standard_section = 'standard_section',
  standard_published_date = 'standard_published_date',
  is_current = 'is_current',
  fire_rated = 'fire_rated',
  notes = 'notes',
  application = 'application',
  application_display_order = 'application_display_order',
  fixing_tested = 'fixing_tested',
  fixing_category = 'fixing_category',
  fixing_group = 'fixing_group',
  industry_category = 'industry_category',
  product = 'product',
  report = 'report',
  fitting_type = 'fitting_type',
  fitting_thickness = 'fitting_thickness',
  product_desc = 'product_desc',
  tile_title = 'tile_title',
  tile_date = 'tile_date',
  tile_description = 'tile_description',
  tile_redirect_url = 'tile_redirect_url',
  tile_image_url = 'tile_image_url',
  certificate_name = 'certificate_name',
  certificate_description = 'certificate_description',
  certificate_url = 'certificate_url',
  system_description = 'system_description',
  multiple_services = 'multiple_services',
  no_of_services = 'no_of_services',
  fixing_test_list = 'fixing_test_list',
  fixing_required = 'fixing_required',
  fixing_note = 'fixing_note',
  is_lagging = 'is_lagging',
  lagging_details = 'lagging_details',
  system_note_type = 'system_note_type',
  system = 'system',
  system_note = 'system_note',
  build_sheet = 'build_sheet',
  display = 'display',
  applies_to = 'applies_to',
  note_title = 'note_title',
  report_ref = 'report_ref',
  report_note_no = 'report_note_no',
  note_image_id = 'note_image_id',
  report_doc_url = 'report_doc_url',
  instruction_doc_url = 'instruction_doc_url',
  document_url = 'document_url'
}
export const selectBoxType = [{ value: 'd', display: 'd' }]
export const generalDictionary: { [key: string]: string } = {
  element_type: 'Element Type',
  element_mod: 'Element Mod',
  element_mod_type: 'Element Mod Type',
  element_mod_details: 'Element Mod Details',
  element_type_display_order: 'Element Type Display Order',
  system_reports: 'System Reports',
  element_material: 'Material',
  element_material_conf: 'Material Conf',
  element_construction: 'Element Construction',
  element_construction_abr: 'Element Construction Abbr',
  element_name: 'Element Name',
  element_abr: 'Element Abbreviation',
  element: 'Element ^',
  element_desc: 'Description',
  element_display_1: 'Element Display 1',
  element_display_2: 'Element Display 2',
  element_orientation: 'Element Orientation',
  thickness: 'Thickness',
  thickness_unit: 'Thickness Unit',
  dim_1_unit: 'Dim 1 Unit',
  dim_2_unit: 'Dim 2 Unit',
  dim_3_unit: 'Dim 3 Unit',
  dim_4_unit: 'Dim 4 Unit',
  dim_1: 'Dim 1',
  dim_2: 'Dim 2',
  dim_3: 'Dim 3',
  dim_4: 'Dim 4',
  dim_1_name: 'Dim 1 Name',
  dim_2_name: 'Dim 2 Name',
  dim_3_name: 'Dim 3 Name',
  dim_4_name: 'Dim 4 Name',
  dim_1_type: 'Dim 1 type',
  dim_2_type: 'Dim 2 type',
  dim_3_type: 'Dim 3 type',
  dim_4_type: 'Dim 4 type',
  frl: 'FRL ^',
  frl_type: 'FRL Type',
  frl_st: 'FRL Structural Adequacy',
  frl_int: 'FRL Integrity',
  fire_rated: 'Fire Rated',
  display_order: 'Display Order',
  frl_structure: 'FRL Structure',
  frl_passive: 'FRL Passive',
  frl_integ: 'FRL Integrity',
  frl_ins: 'FRL Insulation',
  faq_q: 'FAQ Question',
  faq_a: 'FAQ Answer',
  faq_image: 'FAQ Image',
  faq_information_reference: 'FAQ Information Reference URL',
  comp_product_name: 'Component Product Name',
  base_thickness: 'Base thickness',
  added_thickness: 'Added thickness',
  inserted_on: 'Created On',
  updated_on: 'Updated On',
  modified_on: 'Modified On',
  element_notes: 'Notes',
  is_active: 'Active',
  is_private_file: 'Private File',
  inside_diameter_unit: 'Inside diameter unit',
  inside_diameter: 'Inside Diameter',
  product_url: 'Product URL',
  product_qr_url: 'Product QR URL',
  product_manufacturer: 'Product Manufacturer',
  product_brand: 'Product Brand',
  width: 'Width',
  height: 'Height',
  nominal_size_unit: 'Nominal Size Unit',
  nominal_size: 'Nominal Size',
  display_size: 'Display Size',
  product_category: 'Product Category',
  category_display_order: 'Product Category Display Order',
  sub_category_display_order: 'Product Sub Category Display Order',
  sub_category_description: 'Sub Category Description',
  generic_code: 'Generic Code',
  product_installation_type: 'Product Installation Type',
  product_desc: 'Product Description',
  height_unit: 'Height Unit',
  width_unit: 'Width Unit',
  selling_price: 'Selling Price',
  product_code: 'Product Code',
  product_abr: 'Product Abbreviation',
  base_diameter: 'Base Diameter',
  base_diameter_unit: 'Base Diameter Unit',
  sealing_method: 'Sealing Method',
  document_type: 'Document Type',
  doc_type_desc: 'Document Type Description',
  industry_category: 'Industry Category',
  product: 'Product Code',
  unit_name: 'Unit Name',
  service_manufacturer: 'Service Manufacturer',
  service_brand: 'Service Brand',
  system_services: 'System Services',
  system_products: 'System Products',
  system_elements: 'System Elements',
  service_category: 'Service Category',
  service_sub_category: 'Service Sub Category',
  service_sub_cat_name: 'Service Sub Category',
  service_type: 'Service Type',
  description: 'Description',
  service_add: 'Service Add',
  service_add_dim: 'Service Add Dim',
  service_add_unit: 'Service Add Unit',
  service_add_desc: 'Service Add Desc',
  service_add_material: 'Service Add Material',
  service_add_notes: 'Service Add Notes',
  service_add_datasheet_url: 'Service Add Datasheet url',
  service_add_type: 'Service Add Type',
  service_add_brand: 'Service Add Brand',
  service_add_manufacturer: 'Service Add Manufacturer',
  service_add_group: 'Service Add Group',
  service_add_group_desc: 'Service Add Group Desc',
  service_add_group_notes: 'Service Add Group Notes',
  range_details: 'Range Details',
  is_lagging: 'Is Lagging',
  lagging_details: 'Lagging Details',
  build_sheet: 'Build Sheet',
  display: 'Display',
  report: 'Report',
  system_note: 'System Note',
  system_note_type: 'System Note Type',
  applies_to: 'Applies To',
  note_title: 'Note Title',
  report_ref: 'Report Reference',
  report_note_no: 'Report Note No.',
  note_image_id: 'Note Image ID',
  quantity: 'Quantity',
  notes: 'Notes',
  system_id: 'System ID',
  is_range: 'Is range',
  is_primary: 'Is Primary',
  material_name: 'Material Name',
  material_order: 'Material Order',
  orientation: 'Orientation',
  material_conf: 'material Configuration',
  installation_type: 'Installation Type',
  product_type: 'Product Type',
  product_instructions: 'Product Instructions',
  product_notes: 'Product Notes',
  product_docs: 'Product Documnents',
  sub_category_docs: 'Sub Category Images',
  category_name: 'Category Name',
  service_config_name: 'Service Configuration Name',
  config_details: 'Config Details',
  product_sub_category_name: 'Product Sub Category Name',
  product_sub_category: 'Product Sub Category',
  manufacturer_name: 'Manufacturer Name',
  accessory: 'Accessory',
  brand_name: 'Brand Name',
  fixing_category: 'Fixing Category',
  fixing_group: 'Fixing Group',
  instruction_no: 'Instruction No.',
  instruction_code: 'Instruction Code',
  instruction_desc: 'Instruction Description',
  doc_uploaded_date: 'Doc Uploaded Date',
  report_type: 'Report Type',
  release: 'Release',
  publishing_details: 'Publishing Details',
  facility: 'Facility',
  facility_country: 'Facility Country',
  status: 'Status',
  status_details: 'Status Details',
  standard_name: 'Standard Name',
  standard_no: 'Standard No.',
  standard_part: 'Standard Part',
  standard_year: 'Standard Year',
  standard_section: 'Standard Section',
  standard_fullname: 'Standard Fullname',
  standard_country: 'Country',
  standard_published_date: 'Standard Published Date',
  is_current: 'Is Current',
  fitting_type: 'Fitting Type',
  fitting_thickness: 'Fitting Thickeness',
  fitting: 'Fitting',
  fitting_allowed: 'Fitting Allowed',
  system_description: 'System Description',
  fixing_tested: 'Fixing Tested',
  application_name: 'Application Name',
  application_display_order: 'Application Display Order',
  application: 'Application',
  test_date: 'Test date',
  issue_date: 'Issue date',
  expiry_date: 'Expiry date',
  publishing_notes: 'Publishing Notes',
  superseded_date: 'Superseded Date',
  display_status: 'Display Status',
  report_no: 'Report No.',
  report_name: 'Report Name',
  version_no: 'Version No.',
  version_desc: 'Version Description',
  doc_version_desc: 'Version Description',
  version_abre: 'Version Abbreviation',
  dim_type: 'Dimension Type',
  dim_description: 'Dimension Description',
  report_facility: 'Report Facility',
  report_publishing: 'Report Publishing',
  report_status: 'Report Status',
  dbase_type: 'dBase Type',
  additional_pages: 'Additional pages',
  report_doc_url: 'Report Doc URL',
  instruction_doc_url: 'Instruction Doc URL',
  report_standards: 'Report Standards',
  report_notes: 'Report Notes',
  multiple_services: 'Multiple Services',
  no_of_services: 'No. of Services',
  frl_actual: 'FRL Actual ^',
  frl_actual_ins: 'FRL Actual INS',
  frl_actual_int: 'FRL Actual INT',
  frl_actual_st: 'FRL Actual ST',
  frl_issued: 'FRL Issued ^',
  frl_issued_int: 'FRL Issued INT',
  frl_issued_ins: 'FRL Issued INS',
  frl_issued_st: 'FRL Issued ST',
  service_size: 'Service Size',
  service_name: 'Service Name',
  service_abr: 'Service Abbreviation',
  service_material: 'Service Material',
  internal_note: 'Internal Note',
  size_unit: 'Size Unit',
  actual_size: 'Actual size',
  actual_inner_dia: 'Actual Inner Dia.',
  actual_outer_dia: 'Actual Outer Dia.',
  actual_size_tol: 'Actual Size tolerance',
  thickness_tol: 'Thickness tolerance',
  service_standard: 'Service Standard',
  service_std_name: 'Service Std Name',
  service_std_group: 'Service Std Group',
  service_std_no: 'Service td No.',
  service_std_part: 'Service Std Part',
  service_std_year: 'Service Std Year',
  service_std_section: 'Service Std Section',
  service_std_fullname: 'Service Std Fullname',
  service_std_country: 'Service Std Country',
  service_std_published_date: 'Service Std Published Date',
  service_notes: 'Service Notes',
  system_code: 'System Code',
  penetration_no: 'Penetration No.',
  system_component_products: 'System Component Products',
  penetration_depth_unit: 'Penetration Depth Unit',
  penetration_depth: 'Penetration Depth',
  service_configuration: 'Service Configuration',
  system_docs: 'System Docs',
  system_notes: 'System Notes',
  display_record: 'Display Record',
  priority_order: 'Priority Order',
  tile_title: 'Tile Title',
  tile_date: 'Tile Date',
  tile_description: 'Tile Description',
  tile_redirect_url: 'Tile Redirect URL',
  tile_image_url: 'Tile Image',
  fixing_test_list: 'Fixing Tested',
  fixing_required: 'Is Fixing Required',
  fixing_note: 'Fixing note',
  certificate_name: 'Certificate Name',
  certificate_description: 'Certificate Description',
  certificate_url: 'Certificate URL'
}
export const getMatchFromGeneralDictionary = (key: string): string | null => generalDictionary[key] ?? key

// This function returns the inner data for all the types such as ElementTypes, Product Types etc.
export const masterTypesInnerDataForTableRendering = (dataType: string, dataObject: keyValue | string | keyValueObject): string => {
  const data = dataObject as keyValueObject
  if (
    dataType === FormElementNames.is_active ||
    dataType === FormElementNames.is_current ||
    dataType === FormElementNames.display_status ||
    dataType === FormElementNames.fire_rated ||
    dataType === FormElementNames.display_record ||
    dataType === FormElementNames.fixing_required ||
    dataType === FormElementNames.fitting ||
    dataType === FormElementNames.is_private_file ||
    dataType === FormElementNames.is_email_verified ||
    dataType === FormElementNames.is_lagging ||
    dataType === FormElementNames.display ||
    dataType === FormElementNames.build_sheet
  ) {
    return (dataObject as string) ? 'Y' : 'N'
  }

  // If its a string returns the value straight away
  if (typeof data !== 'object') {
    return data
  }

  switch (dataType) {
    case FormElementNames.element_type: {
      if (typeof data === 'string') {
        return data
      }
      return (data?.element_type ?? '') as string
    }
    case FormElementNames.element_mod: {
      return (data?.element_mod_details ?? '') as string
    }
    case FormElementNames.element_mod_type: {
      return (data?.element_mod_type ?? '') as string
    }
    case FormElementNames.element_orientation: {
      return (data?.orientation ?? '') as string
    }
    case FormElementNames.element_material: {
      return (data?.material_name ?? '') as string
    }
    case FormElementNames.element_material_conf: {
      return (data?.material_conf ?? '') as string
    }
    case FormElementNames.product_installation_type: {
      return (data?.installation_type ?? '') as string
    }
    case FormElementNames.installation_type: {
      return (data?.installation_type ?? '') as string
    }
    case FormElementNames.product_manufacturer: {
      return (data?.manufacturer_name ?? '') as string
    }
    case FormElementNames.product_brand: {
      return (data?.brand_name ?? '') as string
    }
    case FormElementNames.product_category: {
      return (data?.category_name ?? '') as string
    }
    case FormElementNames.product_sub_category: {
      return (data?.product_sub_category_name ?? '') as string
    }
    case FormElementNames.product_installations: {
      return (data?.installation_type ?? '') as string
    }
    case FormElementNames.dim_1_type:
    case FormElementNames.dim_2_type:
    case FormElementNames.dim_3_type:
    case FormElementNames.dim_4_type: {
      return (data?.dim_type ?? '') as string
    }
    case FormElementNames.report_standard_list: {
      return (data?.standard_name ?? '') as string
    }
    case FormElementNames.report_facility: {
      return (data?.facility ?? '') as string
    }
    case FormElementNames.report_type: {
      return (data?.report_type ?? '') as string
    }
    case FormElementNames.doc_version_desc: {
      return (data?.version_desc ?? '') as string
    }
    case FormElementNames.report_publishing: {
      return (data?.release ?? '') as string
    }
    case FormElementNames.report_status: {
      return (data?.status ?? '') as string
    }
    case FormElementNames.dbase_type: {
      return (data?.dbase_type ?? '') as string
    }
    case FormElementNames.service_type: {
      return (data?.service_type ?? '') as string
    }
    case FormElementNames.service_standard: {
      return (data?.service_std_name ?? '') as string
    }
    case FormElementNames.service_material: {
      return (data?.service_material ?? '') as string
    }
    case FormElementNames.service_category: {
      return (data?.category_name ?? '') as string
    }
    case FormElementNames.service_configuration: {
      return (data?.service_config_name ?? '') as string
    }
    case FormElementNames.service_sub_category: {
      return (data?.service_sub_cat_name ?? '') as string
    }
    case FormElementNames.service_manufacturer: {
      return (data?.service_manufacturer ?? '') as string
    }
    case FormElementNames.service_brand: {
      return (data?.service_brand ?? '') as string
    }
    case FormElementNames.service_add_manufacturer: {
      return (data?.service_add_manufacturer ?? '') as string
    }
    case FormElementNames.service_add_brand: {
      return (data?.service_add_brand ?? '') as string
    }
    case FormElementNames.service_add_type: {
      return (data?.service_add_type ?? '') as string
    }
    case FormElementNames.service_add_group: {
      return (data?.service_add_group ?? '') as string
    }
    case FormElementNames.service_add: {
      return (data?.service_add ?? '') as string
    }
    case FormElementNames.product_type: {
      return (data?.product_type ?? '') as string
    }
    case FormElementNames.fixing_tested: {
      return (data?.fixing_test_list ?? '') as string
    }
    case FormElementNames.fixing_group: {
      return (data?.fixing_group ?? '') as string
    }
    case FormElementNames.fixing_category: {
      return (data?.fixing_category ?? '') as string
    }
    case FormElementNames.application: {
      return (data?.application_name ?? '') as string
    }
    case FormElementNames.industry_category: {
      return (data?.industry_category ?? '') as string
    }
    case FormElementNames.fitting_type: {
      return (data?.fitting_type ?? '') as string
    }
    case FormElementNames.product: {
      return (data?.product_code ?? '') as string
    }
    case FormElementNames.report: {
      return (data?.report_name ?? '') as string
    }
    case FormElementNames.system_note_type: {
      return (data?.system_note_type ?? '') as string
    }
    case FormElementNames.system: {
      return (data?.system_code ?? '') as string
    }
    case FormElementNames.system_note: {
      return (data?.note_title ?? '') as string
    }
    case FormElementNames.report_doc_url:
    case FormElementNames.instruction_doc_url:
    case FormElementNames.service_add_datasheet_url:
    case FormElementNames.tile_image_url:
    case FormElementNames.certificate_url: {
      return ((data as keyValueObject)?.cdn_url ?? '') as string
    }
    case FormElementNames.document_url: {
      return (data as unknown as URLTypeWithIsPrivate)?.cdn_url ?? ''
    }

    case FormElementNames.element_notes:
    case FormElementNames.product_notes:
    case FormElementNames.service_notes: {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (data !== undefined && data !== null && data) {
        if (Number(data?.length) > 0) {
          const note = (data[0] as keyValueObject) ?? null
          return (note?.element_notes as string) ?? ''
        }
      }
      return ''
    }
    case FormElementNames.report_notes: {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (data !== undefined && data !== null && data) {
        if (Number(data?.length) > 0) {
          const note = (data[0] as keyValueObject) ?? null
          return (note?.notes as string) ?? ''
        }
      }
      return ''
    }
    case FormElementNames.is_active:
    case FormElementNames.is_current:
    case FormElementNames.display_record:
    case FormElementNames.fixing_required:
    case FormElementNames.fitting:
    case FormElementNames.fire_rated:
    case FormElementNames.is_email_verified:
    case FormElementNames.is_lagging:
    case FormElementNames.is_private_file:
    case FormElementNames.display:
    case FormElementNames.build_sheet:
    case FormElementNames.display_status: {
      const value = dataObject as string
      return (value ? 'Y' : 'N') as string
    }
    case FormElementNames.report_standards: {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (data !== undefined && data !== null && data) {
        if (Array.isArray(data) && data.length > 0) {
          const reportName = (data[0] as keyValueObject) ?? null
          const reportStandardObject = reportName?.report_standard_list as keyValueObject
          return (reportStandardObject?.standard_name as string) ?? ''
        }
      }
      return ''
    }

    default:
      return (dataObject as string) ?? '-'
  }
}
export const formMasterTypesInnerData = (
  dataType: string,
  dataObject: keyValue | string | keyValueObject,
  dataObjectRaw: keyValue | string | keyValueObject,
  dataKey?: string | null
): string => {
  const data = dataObject as keyValueObject

  switch (dataType) {
    case FormElementNames.dim_1_type:
    case FormElementNames.dim_2_type:
    case FormElementNames.dim_3_type:
    case FormElementNames.dim_4_type:
    case FormElementNames.element_type:
    case FormElementNames.element_mod:
    case FormElementNames.element_mod_type:
    case FormElementNames.element_orientation:
    case FormElementNames.element_material:
    case FormElementNames.element_material_conf:
    case FormElementNames.product_installation_type:
    case FormElementNames.installation_type:
    case FormElementNames.product_category:
    case FormElementNames.product_sub_category:
    case FormElementNames.product_manufacturer:
    case FormElementNames.product_brand:
    case FormElementNames.product_type:
    case FormElementNames.report_type:
    case FormElementNames.report_facility:
    case FormElementNames.report_publishing:
    case FormElementNames.report_status:
    case FormElementNames.dbase_type:
    case FormElementNames.service_category:
    case FormElementNames.service_sub_category:
    case FormElementNames.service_type:
    case FormElementNames.application:
    case FormElementNames.fixing_tested:
    case FormElementNames.industry_category:
    case FormElementNames.fitting_type:
    case FormElementNames.service_material:
    case FormElementNames.service_standard:
    case FormElementNames.service_manufacturer:
    case FormElementNames.service_brand:
    case FormElementNames.service_add:
    case FormElementNames.service_add_type:
    case FormElementNames.service_add_manufacturer:
    case FormElementNames.service_add_brand:
    case FormElementNames.service_add_group:
    case FormElementNames.tile_title:
    case FormElementNames.tile_description:
    case FormElementNames.tile_redirect_url:
    case FormElementNames.doc_version_desc:
    case FormElementNames.fixing_category:
    case FormElementNames.fixing_group:
    case FormElementNames.report:
    case FormElementNames.system_note_type:
    case FormElementNames.system_note:
    case FormElementNames.system:
      if (dataKey === null) {
        return dataObject as string
      }
      return (data?.id ?? data ?? '') as string
    case FormElementNames.display_status:
    case FormElementNames.is_active:
    case FormElementNames.fixing_required:
    case FormElementNames.is_current:
    case FormElementNames.is_email_verified:
    case FormElementNames.is_private_file:
    case FormElementNames.fire_rated:
    case FormElementNames.is_lagging:
    case FormElementNames.display:
    case FormElementNames.build_sheet:
      return dataObject as string
    default:
      return dataObject as string
  }
}

// This function returns the correct data format for each element as required by GraphQl query.
export const graphQLSendDataMappings = (
  formElementType: string,
  value: string,
  dataKey: string | null
): string | keyValuePair | boolean | keyValueObject | [] | number => {
  if (dataKey === null) {
    if (
      formElementType === FormElementNames.is_active ||
      formElementType === FormElementNames.fixing_required ||
      formElementType === FormElementNames.is_current ||
      formElementType === FormElementNames.fire_rated ||
      formElementType === FormElementNames.display_status ||
      formElementType === FormElementNames.is_private_file ||
      formElementType === FormElementNames.is_email_verified ||
      formElementType === FormElementNames.is_lagging ||
      formElementType === FormElementNames.display ||
      formElementType === FormElementNames.build_sheet
    ) {
      if (!value) {
        return false
      }
      return value.toString() === 'true'
    }
    return value
  }
  switch (formElementType) {
    case FormElementNames.dim_1_type:
    case FormElementNames.dim_2_type:
    case FormElementNames.dim_3_type:
    case FormElementNames.dim_4_type:
    case FormElementNames.element_type:
    case FormElementNames.element_mod:
    case FormElementNames.element_mod_type:
    case FormElementNames.element_orientation:
    case FormElementNames.element_material_conf:
    case FormElementNames.element_material:
    case FormElementNames.product_installation_type:
    case FormElementNames.installation_type:
    case FormElementNames.product_manufacturer:
    case FormElementNames.product_brand:
    case FormElementNames.product_type:
    case FormElementNames.report_facility:
    case FormElementNames.report_status:
    case FormElementNames.dbase_type:
    case FormElementNames.report_type:
    case FormElementNames.report_publishing:
    case FormElementNames.product_category:
    case FormElementNames.product_sub_category:
    case FormElementNames.service_type:
    case FormElementNames.application:
    case FormElementNames.fixing_tested:
    case FormElementNames.service_standard:
    case FormElementNames.service_std_name:
    case FormElementNames.service_manufacturer:
    case FormElementNames.service_brand:
    case FormElementNames.service_material:
    case FormElementNames.service_category:
    case FormElementNames.service_sub_category:
    case FormElementNames.service_add_manufacturer:
    case FormElementNames.service_add_brand:
    case FormElementNames.service_add_type:
    case FormElementNames.service_add_group:
    case FormElementNames.service_add:
    case FormElementNames.industry_category:
    case FormElementNames.doc_version_desc:
    case FormElementNames.fixing_category:
    case FormElementNames.fixing_group:
    case FormElementNames.system_note_type:
    case FormElementNames.report:
    case FormElementNames.system_note:
    case FormElementNames.system:
      return {
        id: parseInt(value, 10)
      }
    case FormElementNames.is_active:
    case FormElementNames.fixing_required:
    case FormElementNames.is_current:
    case FormElementNames.fire_rated:
    case FormElementNames.is_email_verified:
    case FormElementNames.is_private_file:
    case FormElementNames.is_lagging:
    case FormElementNames.display:
    case FormElementNames.build_sheet:
    case FormElementNames.display_status: {
      if (!value) {
        return false
      }
      return value.toString() === 'true'
    }
    case FormElementNames.width_unit: {
      return value
    }
    case FormElementNames.report_doc_url:
    case FormElementNames.instruction_doc_url:
    case FormElementNames.tile_image_url:
    case FormElementNames.certificate_url: {
      // Handle URLType objects that come from SingleFileUpload
      if (typeof value === 'object' && value !== null && 'cdn_url' in value && 'isPrivate' in value) {
        return {
          cdn_url: (value as URLTypeWithIsPrivate).cdn_url,
          is_private_file: (value as URLTypeWithIsPrivate).isPrivate,
          id: (value as URLTypeWithIsPrivate).id
        } as keyValuePair
      }
      // Handle objects that might have __typename (from Apollo cache)
      if (typeof value === 'object' && value !== null && 'cdn_url' in value && 'is_private_file' in value) {
        return {
          cdn_url: (value as URLTypeWithIsPrivateFile).cdn_url,
          is_private_file: (value as URLTypeWithIsPrivateFile).is_private_file,
          id: (value as URLTypeWithIsPrivateFile).id
        } as keyValuePair
      }
      return value
    }

    case FormElementNames.faq_image:
    case FormElementNames.document_url:
    case FormElementNames.service_add_datasheet_url: {
      // Handle URLType objects that come from SingleFileUpload
      if (typeof value === 'object' && value !== null && 'cdn_url' in value && 'isPrivate' in value) {
        return {
          cdn_url: (value as URLTypeWithIsPrivate).cdn_url,
          is_private_file: (value as URLTypeWithIsPrivate).isPrivate,
          id: (value as URLTypeWithIsPrivate).id
        } as keyValuePair
      }
      // Handle objects that might have __typename (from Apollo cache)
      if (typeof value === 'object' && value !== null && 'cdn_url' in value && 'is_private_file' in value) {
        return {
          cdn_url: (value as URLTypeWithIsPrivateFile).cdn_url,
          is_private_file: (value as URLTypeWithIsPrivateFile).is_private_file,
          id: (value as URLTypeWithIsPrivateFile).id
        } as keyValuePair
      }
      return value
    }
    default:
      return value
  }
}
export const getFormElementType = (currentKey: string, dataKey?: string | null): string => {
  // Tries switch case for the elements. Defaults to 'text'
  switch (currentKey) {
    case FormElementNames.added_thickness:
    case FormElementNames.base_thickness:
    case FormElementNames.frl_ins:
    case FormElementNames.frl_st:
    case FormElementNames.frl_integ:
    case FormElementNames.thickness:
    case FormElementNames.selling_price:
    case FormElementNames.nominal_size:
    case FormElementNames.display_size:
    case FormElementNames.dim_1:
    case FormElementNames.dim_2:
    case FormElementNames.dim_3:
    case FormElementNames.dim_4:
    case FormElementNames.height:
    case FormElementNames.width:
    case FormElementNames.base_diameter:
    case FormElementNames.inside_diameter:
    case FormElementNames.actual_size:
    case FormElementNames.actual_outer_dia:
    case FormElementNames.actual_inner_dia:
    case FormElementNames.actual_size_tol:
    case FormElementNames.thickness_tol:
    case FormElementNames.standard_part:
    case FormElementNames.standard_year:
    case FormElementNames.standard_section:
    case FormElementNames.element_type_display_order:
    case FormElementNames.material_order:
    case FormElementNames.application_display_order:
    case FormElementNames.category_display_order:
    case FormElementNames.sub_category_display_order:
    case FormElementNames.display_order:
    case FormElementNames.service_std_part:
    case FormElementNames.service_std_section:
    case FormElementNames.service_std_year:
    case FormElementNames.report_note_no:
    case FormElementNames.note_image_id:
      return 'number'

    case FormElementNames.thickness_unit:
    case FormElementNames.dim_1_unit:
    case FormElementNames.dim_2_unit:
    case FormElementNames.dim_3_unit:
    case FormElementNames.dim_4_unit:
    case FormElementNames.dim_1_type:
    case FormElementNames.dim_2_type:
    case FormElementNames.dim_3_type:
    case FormElementNames.dim_4_type:
    case FormElementNames.element_material:
    case FormElementNames.element_type:
    case FormElementNames.element_mod:
    case FormElementNames.element_mod_type:
    case FormElementNames.element_orientation:
    case FormElementNames.element_material_conf:
    case FormElementNames.product_installation_type:
    case FormElementNames.installation_type:
    case FormElementNames.product_instruction_list:
    case FormElementNames.product_category:
    case FormElementNames.product_sub_category:
    case FormElementNames.product_type:
    case FormElementNames.product_manufacturer:
    case FormElementNames.product_brand:
    case FormElementNames.base_diameter_unit:
    case FormElementNames.inside_diameter_unit:
    case FormElementNames.nominal_size_unit:
    case FormElementNames.service_add_unit:
    case FormElementNames.height_unit:
    case FormElementNames.width_unit:
    case FormElementNames.report_type:
    case FormElementNames.report_facility:
    case FormElementNames.report_publishing:
    case FormElementNames.report_status:
    case FormElementNames.dbase_type:
    case FormElementNames.service_type:
    case FormElementNames.application:
    case FormElementNames.fixing_tested:
    case FormElementNames.service_category:
    case FormElementNames.service_sub_category:
    case FormElementNames.service_manufacturer:
    case FormElementNames.service_brand:
    case FormElementNames.service_standard:
    case FormElementNames.service_material:
    case FormElementNames.size_unit:
    case FormElementNames.service_add_manufacturer:
    case FormElementNames.service_add_brand:
    case FormElementNames.service_add_group:
    case FormElementNames.service_add_type:
    case FormElementNames.service_add:
    case FormElementNames.industry_category:
    case FormElementNames.doc_version_desc:
    case FormElementNames.fixing_category:
    case FormElementNames.fixing_group:
    case FormElementNames.report:
    case FormElementNames.system_note_type:
    case FormElementNames.system:
    case FormElementNames.system_note:
      if (dataKey === null) {
        return 'text'
      }
      return 'select'

    case FormElementNames.frl:
    case FormElementNames.element:
      return 'groupElement'

    case FormElementNames.faq_image:
    case FormElementNames.report_doc_url:
    case FormElementNames.instruction_doc_url:
    case FormElementNames.tile_image_url:
    case FormElementNames.certificate_url:
    case FormElementNames.service_add_datasheet_url:
      return 'url'

    case FormElementNames.test_date:
    case FormElementNames.issue_date:
    case FormElementNames.expiry_date:
    case FormElementNames.superseded_date:
    case FormElementNames.doc_uploaded_date:
    case FormElementNames.standard_published_date:
    case FormElementNames.tile_date:
    case FormElementNames.service_std_published_date:
      return 'date'

    case FormElementNames.is_active:
    case FormElementNames.fixing_required:
    case FormElementNames.is_current:
    case FormElementNames.display_status:
    case FormElementNames.fire_rated:
    case FormElementNames.is_email_verified:
    case FormElementNames.is_lagging:
    case FormElementNames.display:
    case FormElementNames.build_sheet:
      return 'radio'

    case FormElementNames.element_notes:
    case FormElementNames.product_notes:
    case FormElementNames.report_notes:
    case FormElementNames.service_notes:
      return 'notesElement'

    case FormElementNames.product_instructions:
    case FormElementNames.report_standards:
      return 'multiSelect'

    case FormElementNames.product_docs:
    case FormElementNames.system_docs:
    case FormElementNames.sub_category_docs:
      return 'multiFileUpload'

    case FormElementNames.product_desc:
    case FormElementNames.publishing_notes:
    case FormElementNames.sub_category_description:
      return 'textArea'

    case FormElementNames.faq_a:
      return 'richText'

    default:
      return 'text'
  }
}
export const hiddenFormFields = [
  FormElementNames.inserted_on,
  FormElementNames.modified_on,
  FormElementNames.id
  // FormElementNames.report_standard_list
]
export const readOnlyFields = [FormElementNames.inserted_on, FormElementNames.updated_on, FormElementNames.modified_on]
export const requiredFields = [
  FormElementNames.element_name,
  // FormElementNames.thickness,
  // FormElementNames.thickness_unit,
  FormElementNames.element_material,
  FormElementNames.element_type,
  FormElementNames.element_orientation,
  FormElementNames.frl_st,
  FormElementNames.frl_integ,
  FormElementNames.frl_ins,
  FormElementNames.is_active
]
export const formGetGroupElementValues = (key: string): string[] => {
  const getNameWithAppededElementType = (names: FormElementNames[]): string[] => {
    return names.reduce((reducer: string[], item) => {
      const processedString = `${item}_name_${getFormElementType(item)}`
      return [...reducer, processedString]
    }, [])
  }

  switch (key) {
    case FormElementNames.element: {
      const valueToBeReturned = getNameWithAppededElementType([
        FormElementNames.thickness,
        FormElementNames.thickness_unit,
        FormElementNames.element_material,
        FormElementNames.element_type
      ])
      return valueToBeReturned
    }

    case FormElementNames.frl: {
      const valueToBeReturned = getNameWithAppededElementType([FormElementNames.frl_st, FormElementNames.frl_integ, FormElementNames.frl_ins])

      return valueToBeReturned
    }

    default:
      return []
  }
}
export const formGroupingLogic = (key: string): (() => void) | ((array: string[]) => string) | null => {
  switch (key) {
    case FormElementNames.frl: {
      return (array: string[]): string => {
        return array.reduce(
          (reducer: string, item: string, index) => `${reducer}${parseInt(item) === 0 ? '-' : item}${index < array.length - 1 ? '/' : ''}`,
          ''
        )
      }
    }

    case FormElementNames.element: {
      return (array: string[]): string => {
        return array.reduce((reducer: string, item: string, index) => {
          const getDelimiter = (arrayIndex: number | boolean): string => {
            switch (arrayIndex) {
              case 1:
                return ' '
              case 2:
                return ' '
              default: {
                return ''
              }
            }
          }
          return `${reducer}${item}${getDelimiter(index)}`
        }, '')
      }
    }

    default: {
      return (array: string[]): string => {
        return array.reduce((reducer: string, item: string, index) => `${reducer}${item}${index < array.length - 1 ? '-' : ''}`, '')
      }
    }
  }
}
export const getFormValidation = (key: string): keyValue => {
  switch (key) {
    case FormElementNames.frl_st:
    case FormElementNames.frl_integ:
    case FormElementNames.frl_ins:
      return {
        max: 1000,
        min: 0
      }

    default:
      return { min: 0, step: 'any' }
  }
}
